import { RxJS } from './RxJS'
import { RxJSState } from './RxJSState'
import { ApplicationResponseNotification, JSONResponse } from '../Types/Types'
import { getUserSettings } from '../API/EntityAPIClient'

export const fetchUserSettings = (): Promise<Nullable<ApplicationResponseNotification>> =>
    getUserSettings()
        .then((response: JSONResponse<ApplicationResponseNotification>) => {
            RxJS.userSettings?.announce(response ?? undefined)
            return response
        })
        .catch(() => {
            RxJS.userSettings?.announce(undefined)
            return null
        })

RxJS.userSettings =
    RxJS.userSettings ??
    RxJSState.newInstance<ApplicationResponseNotification, () => Promise<Nullable<ApplicationResponseNotification>>>(
        'userSettings',
        fetchUserSettings
    )

export const userSettings$ = RxJS.userSettings
